import { render, staticRenderFns } from "./SocialsBlock.vue?vue&type=template&id=16cc635b"
import script from "./SocialsBlock.vue?vue&type=script&lang=ts"
export * from "./SocialsBlock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports